import styled from 'styled-components';
import { Swatches, Clock, PaintBrush, Globe } from '@phosphor-icons/react';
import { Container } from '@/components/common/Container';
import { Section } from '@/components/common/Section';
import { FeatureCard } from '@/components/shared/FeatureCard';
import { theme } from '@/styles/theme';

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: ${theme.spacing.xxxl};
  color: ${theme.colors.text.black};
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${theme.spacing.xl};

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const features = [
  {
    icon: <Swatches size={32} weight="duotone" />,
    title: 'Swipe-Based Learning',
    description: 'Right if you know it, left if you\'re learning. Simple, intuitive, and satisfying.',
  },
  {
    icon: <Clock size={32} weight="duotone" />,
    title: 'Spaced Repetition',
    description: 'See words at the perfect moment for memory retention. Science-backed learning.',
  },
  {
    icon: <PaintBrush size={32} weight="duotone" />,
    title: 'Beautiful Themes',
    description: 'Calming environments that help you focus. Forest, Beach, and Library themes available.',
  },
  {
    icon: <Globe size={32} weight="duotone" />,
    title: 'Multilingual',
    description: 'Supporting English, French, German, Italian, and Spanish.',
  },
];

interface FeaturesSectionProps {
  id?: string;
}

export const FeaturesSection = ({ id }: FeaturesSectionProps) => {
  return (
    <Section $padding="large" id={id}>
      <Container>
        <SectionTitle>Learning vocabulary should feel this simple</SectionTitle>
        <FeaturesGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </FeaturesGrid>
      </Container>
    </Section>
  );
};
